import React from 'react';
import { action, observable, makeObservable, runInAction } from 'mobx';

const DRAWER_EXIT_MS = 220;

export class DrawerStore {
	@observable isOpen = false;
	@observable isClosing = false;
	@observable containerId = '';
	@observable title = null;
	@observable drawerId = null;
	@observable drawerComponentProps = {};
	@observable drawerComponent = null;
	@observable customHeader = null;
	@observable showHeader = true;

	_closeTimeout = null;

	DRAWER_IDS = {
		JOB_POSITION_PROFILE: 'job-position-profile',
		APPLICANT_PROFILE: 'applicant-profile',
		CLIENT_PROFILE: 'client-profile',
		EXTERNAL_APPLICATION_PROFILE: 'external-application-profile',
		FILTER_DRAWER: 'filter-drawer'
	};

	constructor() {
		makeObservable(this);
	}

	@action
	openDrawer(
		{
			containerId,
			title,
			drawerId,
			onClose,
			customHeader,
			props = {},
			showHeader = true
		},
		drawerComponent
	) {
		if (this._closeTimeout) {
			clearTimeout(this._closeTimeout);
			this._closeTimeout = null;
		}

		this.isClosing = false;
		this.isOpen = true;
		this.containerId = containerId;
		this.title = title;
		this.drawerId = drawerId;
		this.onClose = onClose;
		this.drawerComponent = drawerComponent;
		this.drawerComponentProps = props;
		this.customHeader = customHeader;
		this.showHeader = showHeader;
	}

	@action
	updateDrawerProps(newProps) {
		Object.assign(this.drawerComponentProps, newProps);
	}

	@action
	closeDrawer() {
		if (!this.isOpen || this.isClosing) {
			return;
		}

		this.isClosing = true;
		const onClose = this.onClose;

		this._closeTimeout = setTimeout(() => {
			runInAction(() => {
				this.isOpen = false;
				this.isClosing = false;
				this.containerId = '';
				this.title = null;
				this.drawerId = null;
				this.drawerComponent = null;
				this.drawerComponentProps = {};
				this.customHeader = null;
				this.showHeader = true;
				this.onClose = null;
				this._closeTimeout = null;
			});
			onClose && onClose();
		}, DRAWER_EXIT_MS);
	}

	getDrawerComponent() {
		if (this.isOpen) {
			return React.createElement(
				this.drawerComponent,
				this.drawerComponentProps
			);
		}
		return null;
	}
}

const drawerStore = new DrawerStore();
export { drawerStore };
